<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <relatorio-cancelados-list-concluidos
      :headers="headers"
      :tela="permission"
      ref="concluidos"
      @loading="loading = true"
      @loaded="loading = false"
    />
  </div>
</template>

<script>
import RelatorioCanceladosListConcluidos from './RelatorioCanceladosListConcluidos.vue'
import { Sequences } from '@/utils/permissions'
export default {
  name: 'RelatorioCanceladosList',
  props: {
    headers: {
      type: Array,
    },
  },
  components: {
    RelatorioCanceladosListConcluidos,
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async handleGetAgendamentos() {
      await this.$refs.concluidos.handleGetAgendamentos()
    },
  },
   computed: {
    permission() {
      return Sequences.Cancelados.toString()
    },
  },
}
</script>
